import { useMemo, useState } from "react";

import { Sport } from "../../../redux/slices";
import { BasketballPlayerLabelType, HockeyPlayerLabelType, SoccerPlayerLabelType } from "../../../types";

export interface BasketballPositionLabel {
  sport: Sport.BASKETBALL;
  labelType: BasketballPlayerLabelType;
}

export interface HockeyPositionLabel {
  sport: Sport.HOCKEY;
  labelType: HockeyPlayerLabelType;
}

export interface SoccerPositionLabel {
  sport: Sport.SOCCER;
  labelType: SoccerPlayerLabelType;
}

type LabelType = BasketballPlayerLabelType | HockeyPlayerLabelType | SoccerPlayerLabelType;
export type PositionLabelType = BasketballPositionLabel | HockeyPositionLabel | SoccerPositionLabel;

export interface UseToolPaletteApiProps {
  sport: Sport;
}

export const useToolPaletteApi = ({ sport }: UseToolPaletteApiProps) => {
  const defaultLabelType = useMemo((): PositionLabelType => {
    switch (sport) {
      case Sport.BASKETBALL:
        return { sport, labelType: "NUM" };
      case Sport.HOCKEY:
        return { sport, labelType: "FD" };
      case Sport.SOCCER:
        return { sport, labelType: "POS" };
      case Sport.NO_SPORT:
        throw new Error(`invalid sport: ${sport}`);
    }
  }, [sport]);

  const [positionLabelType, setPositionLabelType] = useState<PositionLabelType>(defaultLabelType);

  const togglePositionLabelType = () => {
    setPositionLabelType((prevState) => {
      switch (prevState.sport) {
        case Sport.BASKETBALL:
        case Sport.SOCCER:
          return prevState;
        case Sport.HOCKEY:
          return { ...prevState, labelType: prevState.labelType === "FD" ? "LR" : "FD" };
      }
    });
  };

  const changePositionLabelType = (labelType: LabelType) => {
    setPositionLabelType((prevState) => {
      switch (prevState.sport) {
        case Sport.BASKETBALL:
        case Sport.HOCKEY:
          return prevState;
        case Sport.SOCCER: {
          if (labelType === "NUM" || labelType === "POS" || labelType === "o")
            return { ...prevState, labelType: labelType };
          else return prevState;
        }
      }
    });
  };

  return { positionLabelType, togglePositionLabelType, changePositionLabelType };
};

export type ToolPaletteApi = ReturnType<typeof useToolPaletteApi>;

export const DEFAULT_TOOL_PALETTE_API: ToolPaletteApi = {
  positionLabelType: { sport: Sport.BASKETBALL, labelType: "NUM" },
  togglePositionLabelType: () => undefined,
  changePositionLabelType: () => undefined,
};
